import axios from "axios";

export const getColonias = async (codigoPostal) => {
  return axios
    .get(
      `${process.env.REACT_APP_API_URL}/Informacion/Colonias/${codigoPostal}`
    )
    .then((response) => {
      return Promise.resolve(response.data);
    })
    .catch((error) => {
        // Mensajes de error del api
      if (error.response.status > 400 && error.response.status < 500) {
        return Promise.reject(error.response.data);
      }
    //   Algo falló en el servidor
      return Promise.reject("Hubo un error al cargar las colonias");
    });
};

export const getRIFs = async (personaFisica) => {
  const url = new URL(
    `${process.env.REACT_APP_API_URL}/Informacion/regimenesfiscales`
  );
  url.searchParams.append("personaFisica", personaFisica);

  return axios
    .get(url)
    .then((response) => {
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      return Promise.reject("Hubo un error al cargar los RIF");
    });
};

export const getcfdis = async (rif) => {
  const url = new URL(
    `${process.env.REACT_APP_API_URL}/Informacion/usosfiscales/${rif}`
  );
  return axios
    .get(url)
    .then((response) => {
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      return Promise.reject("Hubo un error al cargar los CFDI");
    });
};

export const getFormasPago = async (fomrasPago) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/Informacion/formaspago`)
    .then((response) => {
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      return Promise.reject("Hubo un error al cargar las formas de pago");
    });
};
